import { Tooltip } from "antd";
import { ReactNode } from "react";

interface Props {
  buckets: string[];
  color?: string;
  children: ReactNode;
}

export default function BucketTooltip({ buckets, color = "#6B4EFF", children }: Props) {
  if (!buckets.length) return <>{children}</>;

  const title = (
    <div style={{ padding: "2px 2px" }}>
      <div
        style={{
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: "0.05em",
          textTransform: "uppercase",
          color: "rgba(0,0,0,0.4)",
          marginBottom: 8,
          paddingBottom: 6,
          borderBottom: "1px solid rgba(0,0,0,0.06)",
        }}
      >
        Includes {buckets.length} bucket{buckets.length > 1 ? "s" : ""}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {buckets.map((name) => (
          <div key={name} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12.5, color: "rgba(0,0,0,0.82)", whiteSpace: "nowrap" }}>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: color, flexShrink: 0 }} />
            {name}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <Tooltip
      title={title}
      color="#fff"
      placement="top"
      overlayInnerStyle={{
        padding: 12,
        borderRadius: 10,
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
      }}
    >
      {children}
    </Tooltip>
  );
}
